import * as Yup from 'yup';
import { AbsenceType } from '@models';

export function useValidationSchema() {
  return Yup.object<AbsenceType>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<AbsenceType>;
}
